import type { UseFormReturn } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { msg } from '@gonfalon/messages/msg';
import { FieldGroup, Input, Label, TextField } from '@launchpad-ui/components';

import type { MetricForm } from '../../../CreateMetricModal/formUtils';

import styles from './UnitFormField.module.css';

interface UnitFormFieldProps {
  context: UseFormReturn<MetricForm>;
  /** Id of a label the caller renders instead, such as a row's label in the sectioned layout. */
  'aria-labelledby'?: string;
}

const FIELD_NAME = 'unit';

export const UnitFormField: React.FC<UnitFormFieldProps> = ({ context, 'aria-labelledby': labelledBy }) => {
  const { register } = context;
  const value = useWatch({ control: context.control, name: FIELD_NAME });

  return (
    <FieldGroup>
      <TextField aria-labelledby={labelledBy}>
        {labelledBy === undefined && <Label htmlFor={FIELD_NAME}>{msg('metrics.metricForm.unitLabel')}</Label>}
        <Input
          {...register(FIELD_NAME, { shouldUnregister: true })}
          value={value}
          placeholder={msg('metrics.metricForm.unitPlaceholder')}
          id={FIELD_NAME}
          className={styles.unitFormFieldInput}
        />
      </TextField>
    </FieldGroup>
  );
};
